import utf8 from 'utf8'

const disconnectTextGenerator = (chanelName) => {
    let str = ''
    if (chanelName) {
        chanelName.forEach((item, index) => {
            str = str + utf8.decode(item) + (index < chanelName.length - 1 ? ' و ' : ' ')
        })

        return chanelName.length > 1 ? `ارتباط موبیشا با پنل‌های ${str} قطع شده است.` : `ارتباط شما با پنل ${str} قطع شده است.`
    } else {
        return 'ارتباط موبیشا با پنل‌ قطع شده است!'
    }
}
export default disconnectTextGenerator